<template>
  <div class="popup">
    <div class="bg-modal"></div>
    <div class="common-alert alert">
      <div class="alert-tlt">
        <p>상품 생성</p>
        <button class="btn-close" @click="closeUploadExcelModal">
          <img src="/static/img/ico-close.png" alt />
        </button>
      </div>
      <div class="alert-desc">
        <div class="row-group">
          <div class="info-row">
            <h3 class="info-tlt">엑셀파일</h3>
            <span class="info-box">
              <input type="file" multiple="false" id="filename"
                accept="application/x-iwork-keynote-sffnumbers,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="onChange" />
            </span>
          </div>
        </div>
      </div>
      <div class="alert-btn alert-btn-2">
        <button class="btn-green-line btn-default" @click="closeUploadExcelModal">취소</button>
        <button class="btn-green btn-default" @click="excuteCreate">
          <span v-if="!uploadLoading" class="process">생성</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'company',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    excelFile: null,
    uploadLoading: false,
  }),
  created() {
  },
  methods: {
    async excuteCreate() {
      this.uploadLoading = true;
      if (this.excelFile === null) {
        alert('파일을 선택해 주세요');
        this.uploadLoading = false;
        return;
      }
      if (this.excelFile.length > 1) {
        alert('한개의 파일만 업로드 가능합니다.');
        this.uploadLoading = false;
        return;
      }

      /*
      if (!confirm('정말로 진행 하시겠습니까?')) {
        return;
      }
      */

      js2excel.excel2json(
        this.excelFile.target.files,
        (data) => {
          const keys = Object.keys(data);
          for (let s = 0; s < keys.length; s++) {
            const json = data[keys[s]];
            if (json.length === 0) {
              continue;
            }
            const products = [];
            for (let i = 0; i < json.length; i++) {
              const it = json[i];
              if (!it.companyID) {
                continue;
              }
              if (this.company.id !== it.companyID) {
                alert('엑셀파일의 companyID, divisionID를 확인해 주세요');
                this.uploadLoading = false;
                return;
              }
              const p = {
                productName: it.productName,
                productEngName: it.productEngName,
                productType: it.productType,
                supplyPrice: parseInt(it.supplyPrice, 10),
                salePrice: parseInt(it.salePrice, 10),
                weight: parseFloat(it.weight),
                expirePeriod: parseInt(it.expirePeriod, 10),
                barcode: it.barcode,
                //
                companyID: it.companyID,
                divisionID: it.divisionID ? it.divisionID : null,
              };
              products.push(p);
            }

            if (products.length === 0) {
              alert('업로드할 내용이 없습니다...');
              this.uploadLoading = false;
              return;
            }

            const request = {
              products,
            };

            this.createByExcel(request);
          }
        },
        null, // default value
      );
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ excel2json }) => {
        excel2json(this.excelFile.target.files, (data) => {
        }, 'excel2json');
      }).catch((e) => {

      });
      */
    },
    async createByExcel(request) {
      try {
        const createUrl = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/product/list`;

        const createResult = await this.$http.post(createUrl,
          request,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        this.uploadLoading = false;
        this.$emit('createComplete');
      } catch (e) {
        alert('생성에 실패하였습니다.');
        console.error(e);
        this.uploadLoading = false;
        this.$emit('createComplete');
      }
    },
    closeUploadExcelModal() {
      this.$emit('closeUploadExcelModal');
    },
    onChange(value) {
      this.excelFile = value;
    },
  },
};
</script>

<style scoped>
.popup{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.bg-modal{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
}
.alert{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 4px;
  padding: 0 16px;
  width: auto;
}

.alert-tlt{
  width: 100%;
/*  height: 34px;*/
  height: 38px;
  border-bottom: 0.5px solid #8B9296;
/*  padding-top: 12px;*/
  padding-top: 14px;
  overflow: hidden;
}
.alert-tlt p{
  font-size: 12px;
  color: #8B9296;
  float: left;
}
.alert-tlt .btn-close{
  width: 14px;
  height: 14px;
  float: right;
  opacity: 38%;
  cursor: pointer;
}
.alert-tlt .btn-close img{
  width: 100%;
}
.alert-desc{
  width: 100%;
  height: auto;
  margin-top: 16px;
}

.alert-btn{
  overflow: hidden;
  height: 40px;
  margin: 24px auto;
}
.alert-btn button{
  float: left;
  height: 100%;
/*  width: 100%;*/
  text-align: center;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}
.common-alert {
  width: 392px;
  height: auto;
}
.btn-green{
  border: 1px solid #38b78f;
  background-color: #38b78f;
  color: #fff;
}
.btn-green-line{
  border: 1px solid #38b78f;
  color: #38b78f;
}
.btn-blue{
  border: 1px solid #3aa7b1;
  background-color: #3aa7b1;
  color: #fff;
}
.btn-blue-line{
  border: 1px solid #3aa7b1;
  color: #3aa7b1;
}
.btn-gray{
  border: 1px solid #d7dadb;
  background-color: #d7dadb;
  color: #fff;
}
.btn-gray-line{
  border: 1px solid #8B9296;
  color: #8B9296;
}
.btn-red{
  border: 1px solid #F44336;
  background-color: #F44336;
  color: #fff;
}
.btn-red-line{
  border: 1px solid #F44336;
  color: #F44336;
}
.btn-default{
  transition: 0.3s;
}
.btn-default:hover{
  border: 1px solid #263339;
  background-color: #263339;
  color: #fff;
}
.alert-btn-2{
  width: 216px;
}
.alert-btn-2 button{
  width: 100px;
}
.alert-btn-2 button:first-child{}
.alert-btn-2 button:last-child{
  margin-left: 16px;
}
.row-group{
  width: 100%;
  height: auto;
}
.row-group .info-row{
  width: 100%;
}
.info-row .info-tlt{
  font-size: 14px;
  font-weight: 500;
}
.info-row .info-box{
  display: block;
  width: 100%;
  height: 46px;
  border-radius: 4px;
  border: solid 1px #d7dadb;
  background-color: #ffffff;
  margin: 8px 0;
}
.info-row .info-box input{
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  padding: 13px 12px;
  font-size: 14px;
  font-weight: 500;
}
.info-row .info-box.text{
  padding: 13px 12px;
}
.info-row .info-box select {
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  padding: 13px 12px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/UploadExcelModal.vue